"use client";
import { useEffect, useState } from "react";

const SingleCardDetails = ({
	data,
	facility,
}: {
	data: any;
	facility?: boolean;
}) => {
	const [facilityDetailsData, setFacilityDetailsData] = useState<any[]>([]);

	useEffect(() => {
		if (facility && data?.extra_columns) {
			const details = JSON.parse(data?.extra_columns);
			const transformedData = Object.keys(details)?.reduce(
				(acc: { label: any; value: any }[], key) => {
					if (key.startsWith("header_")) {
						const subHeaderKey = `sub_header_${key.split("_")[1]}`;
						acc.push({ label: details[key], value: details[subHeaderKey] });
					}
					return acc;
				},
				[]
			);

			setFacilityDetailsData(transformedData);
		}
	}, [facility]);

	return (
		<div className="details flex justify-between pr-[1.4rem] lg:pr-0 lg:justify-normal lg:flex-col gap-6 ">
			{!facility ? (
				<>
					<div>
						<div className="text-bodyM font-national ">Bedrooms</div>

						<div className="text-bodyL lg:text-h5">{data?.bedrooms?.en}</div>
					</div>
					<div>
						<div className="text-bodyM font-national ">SQM</div>

						<div className="text-bodyL lg:text-h5">{data?.sqft?.en}</div>
					</div>
				</>
			) : (
				<>
					{facilityDetailsData &&
						facilityDetailsData?.map((item, index) => (
							<div key={index}>
								<div className="text-bodyM font-national">{item?.label}</div>
								<div className="text-bodyL lg:text-h5">{item?.value}</div>
							</div>
						))}
				</>
			)}
		</div>
	);
};

export default SingleCardDetails;
